module.exports = function (Chart) {

  var helpers = Chart.helpers,
    defaults = Chart.defaults;

  defaults.rawImage = {
    legend: false,

    tooltips: {
      callbacks: {
        title(){
          return '';
        },
        label(tooltipItem, data){
          return data.labels[tooltipItem.index];
        }
      }
    }
  };

  Chart.controllers.rawImage = Chart.DatasetController.extend({

    dataElementType: Chart.elements.Image,

    linkScales: helpers.noop,

    image: null,

    removeHoverStyle: function (element) {

    },

    setHoverStyle: function (element) {

    },

    update: function (reset) {
      var me = this,
        meta = me.getMeta();

      helpers.each(meta.data, function (img, index) {
        me.updateElement(img, index, reset);
      });
    },

    updateElement(img, index, reset){
      var me = this,
        chart = me.chart.chart;

      if (!me.image || reset) {
        me.image = me.createImage(index);
        me.image.onload = function () {
          me.update.call(me, false);
        };
      }

      helpers.extend(img, {
        _model: {
          img: me.image,
          x: (chart.width - me.image.width) / 2,
          y: (chart.height - me.image.height) / 2,
          width: me.image.width,
          height: me.image.height
        }
      });
    },

    createImage(index){
      var me = this,
        dataset = me.getDataset(),
        config = dataset.data[index];

      var img = new Image(config.width, config.height);
      img.src = config.url;

      return img;
    }
  });
};

